export const DEALER = "dealer";
export const RETAILER = "retailer";
export const ADMIN = "admin";
export const SALESMAN = "seller";
